import 'es6-promise/auto';
import 'babel-polyfill';
import './plugins/vee-validate';
import './plugins/d2kit';
import Vue from 'vue';
import axios from 'axios';
import D2Auth from '@devsquared/auth';
import VueRouter from 'vue-router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import VueTheMask from 'vue-the-mask';
import store from './store';
import { router } from './routing';
// import InstantSearch from 'vue-instantsearch';
// Use 'vue-instantsearch/vue3/es' for Vue 3

Vue.use(VueRouter);
Vue.use(D2Auth);

Vue.use(VueTheMask);
// Vue.use(InstantSearch);
library.add(fab);

window.Vue = Vue;
window.axios = axios;

Vue.config.productionTip = false;

const resourceFiles = require.context('~/Resources', true, /\.vue$/i);
const viewFiles = require.context('~/Views', true, /\.vue$/i);

// eslint-disable-next-line
resourceFiles.keys().map((key) => {
  const component = resourceFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], resourceFiles(key).default);
  }
});

// eslint-disable-next-line
viewFiles.keys().map((key) => {
  const component = viewFiles(key).default;
  if (component.parent) {
    Vue.component(key.split('/').pop().split('.')[0], viewFiles(key).default);
  }
});

const elem = document.getElementById('loadCover');
elem.parentNode.removeChild(elem);

const vueApp = new Vue({
  store,
  router,
});

vueApp.$d2Auth.setRoles(window.roles);
vueApp.$d2Auth.setClaims(window.claims);
vueApp.$d2Auth.setUserProfile(window.user);
vueApp.$d2Auth.setCurrentCompany(window.company);
vueApp.$mount('#vue-wrapper');